import { isEmptyData } from '~/utils/tool';
import type { BetterForm } from '@magicdoorinc/form';

export const isFalsy = (value: any) => {
  return value === undefined || value === null || value === '';
};

export const isFormStoreChanged = function <T extends Record<string, any>>(initData: T | undefined, store: BetterForm.FormStore) {
  if (!initData) return !isEmptyData(store);
  return Object.keys(store).some((key) => initData[key] !== store[key]);
};
